import Link from '../link'
import AuthCard from './auth-card'
import LoginForm from './login-form'

const Login = () => {
  const footer = (
    <span className="text-base">
      Don’t have an account? <Link href="sign-up" text="Register" />
    </span>
  )
  return (
    <AuthCard title="Login" footer={footer}>
      <LoginForm />
    </AuthCard>
  )
}

export default Login
